import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Mic, TrendingUp, Settings } from 'lucide-react';
import { TEST_IDS } from '../../constants/testIds';

const items = [
  { to: '/', icon: LayoutDashboard, label: 'Home', testId: TEST_IDS.BOTTOM_NAV_DASHBOARD },
  { to: '/interviews', icon: Mic, label: 'Interview', testId: TEST_IDS.BOTTOM_NAV_INTERVIEWS },
  { to: '/progress', icon: TrendingUp, label: 'Insight', testId: TEST_IDS.BOTTOM_NAV_PROGRESS },
  { to: '/settings', icon: Settings, label: 'Settings', testId: TEST_IDS.BOTTOM_NAV_SETTINGS },
];

export default function BottomNav() {
  return (
    <nav
      data-testid={TEST_IDS.BOTTOM_NAV}
      className="md:hidden fixed bottom-0 left-0 right-0 h-16
                 border-t border-border bg-background/80 glass-bar z-50
                 flex justify-around items-center px-2"
    >
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          data-testid={item.testId}
          className={({ isActive }) =>
            `flex flex-col items-center gap-0.5 px-4 py-1.5 rounded-lg transition-colors
             ${isActive ? 'text-[#3D1F6E] dark:text-[#A78BFA]' : 'text-muted-foreground'}`
          }
        >
          <item.icon className="w-5 h-5" />
          <span className="text-[10px] font-medium font-heading">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
